var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-block-editor send-json-response" },
    [
      _c("div", { staticClass: "editor-row customize-editor-minimize" }, [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Response Mode:"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btnGroup" },
          _vm._l(["json", "raw"], function (type) {
            return _c(
              "SupsisButton",
              {
                key: type,
                attrs: {
                  classNames:
                    _vm.clone.mode === type
                      ? "btnGroupItem selected"
                      : "btnGroupItem ",
                  primary: _vm.clone.mode === type,
                  ghost: _vm.clone.mode !== type,
                  small: "",
                },
                on: {
                  click: function () {
                    return _vm.changeMode(type)
                  },
                },
              },
              [_vm._v("\n                " + _vm._s(type) + "\n            ")]
            )
          }),
          1
        ),
      ]),
      _vm._v(" "),
      _vm.clone.mode === "raw"
        ? _c(
            "div",
            { staticClass: "editor-row customize-editor-minimize" },
            [
              _c("div", { staticClass: "editor-row-title" }, [
                _vm._v("Raw Content Type"),
              ]),
              _vm._v(" "),
              _c("CustomPicker", {
                attrs: {
                  title: "Select Content Type",
                  icon: "receipt_long",
                  items: _vm.rawContentTypeOptions,
                  idKey: "id",
                  labelKey: "label",
                },
                model: {
                  value: _vm.clone.rawContentType,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "rawContentType", $$v)
                  },
                  expression: "clone.rawContentType",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "raw"
        ? _c("div", { staticClass: "editor-row customize-editor-minimize" }, [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v("Raw Response"),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "monaco-raw-editor-container",
              attrs: { id: "monaco-raw-editor-container" },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.clone.mode === "json"
        ? _c(
            "div",
            { staticClass: "editor-row customize-editor-minimize data-items" },
            [
              _c("div", { staticClass: "editor-row-title" }, [
                _vm._v("Response Data"),
              ]),
              _vm._v(" "),
              _vm._l(_vm.clone.data || [], function (item, index) {
                return _c("DataItem", {
                  key: index,
                  on: {
                    delete: function () {
                      return _vm.deleteDataItem(index)
                    },
                  },
                  model: {
                    value: _vm.clone.data[index],
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.data, index, $$v)
                    },
                    expression: "clone.data[index]",
                  },
                })
              }),
              _vm._v(" "),
              _c(
                "SupsisButton",
                {
                  attrs: { small: "", ghost: "" },
                  on: { click: _vm.addDataItem },
                },
                [_vm._v(" Add Data Field")]
              ),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }